module.exports = __webpack_public_path__ + "static/media/surface1.61a3291e.svg";